import {
  Text,
  Colors,
  useMediaQuery,
  MediaQueryBreakpoints,
  staticCdnHost,
} from '@rockalingua/ui';

import {
  Container,
  StyledCarousel,
  CarouselItemContainer,
  CarouselItem,
  DescriptionContainer,
  NameAndTitleContainer,
  QuoteIcon,
} from './Carousel.styled';

type TeacherFeedbackItem = {
  name: string;
  title: string;
  description: string;
};

export default function Carousel({ items }: { items: TeacherFeedbackItem[] }) {
  const xsm = useMediaQuery({
    query: `(max-width: ${MediaQueryBreakpoints.xsm}px)`,
  });

  const sm = useMediaQuery({
    query: `(max-width: ${MediaQueryBreakpoints.sm}px)`,
  });

  const md = useMediaQuery({
    query: `(max-width: ${MediaQueryBreakpoints.md}px)`,
  });

  const lg = useMediaQuery({
    query: `(max-width: ${MediaQueryBreakpoints.lg}px)`,
  });

  const getCenterPadding = () => {
    if (xsm) {
      return '0px';
    }
    if (sm) {
      return '100px';
    }
    if (md) {
      return '200px';
    }
    if (lg) {
      return '400px';
    }
    return '500px';
  };

  return (
    <Container>
      <StyledCarousel
        initialSlide={1}
        arrows={false}
        infinite={true}
        centerMode={true}
        centerPadding={getCenterPadding()}
        slidesToShow={1}
      >
        {items.map((item, idx) => {
          return (
            <CarouselItemContainer key={idx}>
              <CarouselItem>
                <QuoteIcon
                  src={`${staticCdnHost}/img/quotes-icon.svg`}
                  alt="Quotes icon"
                />
                <DescriptionContainer>
                  <Text variant="title-small-grey-22" color={Colors.BLACK}>
                    &ldquo;{item.description}&rdquo;
                  </Text>
                </DescriptionContainer>
                <NameAndTitleContainer>
                  <Text variant="grey-22-bold" color={Colors.BLACK}>
                    {item.name}
                  </Text>
                  <Text
                    variant="title-small-grey-22"
                    color={Colors.NEUTRAL_VARIANTS[60]}
                  >
                    {item.title}
                  </Text>
                </NameAndTitleContainer>
              </CarouselItem>
            </CarouselItemContainer>
          );
        })}
      </StyledCarousel>
    </Container>
  );
}
